import TicketsWindow from './tickets';

import '../styles/operation.css';

// Operación: lo que pasa DESPUÉS de que algo está desplegado.
//
// Las otras secciones del panel miran hacia adelante — qué se planea, cómo se
// parte, quién lo hace, quién lo revisa. Esta mira hacia atrás, a lo que ya está
// andando y alguien usó. Por eso es una sección y no una pestaña de Desarrollo:
// un ticket no es una tarea ni se convierte en una, y meterlos en la misma
// pantalla habría sugerido lo contrario.
//
// TRES VENTANAS PLANEADAS, UNA CONSTRUIDA. Acá van tickets (lo que la gente
// reportó), logs (lo que la máquina registró) y changelogs (qué cambió y
// cuándo). Hoy solo existe la primera, y no por falta de ganas: de las tres,
// tickets es la única que el backend publica.
//
// HOY NO LLEVA PESTAÑAS, entonces. Una barra de pestañas con una pestaña es un
// mueble vacío. Cuando aparezca la segunda, la barra aparece con ella — como
// pasó en Desarrollo, que empezó siendo tres entradas del riel.
//
// LO QUE FALTA SE DICE EN EL PIE y no se deja adivinar. Una sección que
// aparenta estar completa es la forma más cara de esconder un pendiente: el
// próximo que la abra va a buscar el changelog, no encontrarlo, y perder media
// hora averiguando si está roto o si no existe.

export default function OperationScreen() {
    return (
        <section className="operation">
            <header className="operation__header">
                <div className="operation__heading">
                    <span className="operation__eyebrow">Lo que ya está andando</span>
                    <h2 className="operation__title">Operación</h2>
                </div>
            </header>

            <div className="operation__panel">
                <TicketsWindow />
            </div>

            <footer className="operation__foot">
                <p className="operation__note">
                    <strong>Esta sección va a tener tres ventanas y hoy tiene una.</strong>{' '}
                    Faltan <strong>logs</strong> y <strong>changelogs</strong>, y no es que
                    estén a medio hacer: el backend no publica ninguna de las dos. Lo más
                    parecido que existe hoy es el registro de eventos, que ya se lee en{' '}
                    <em>En vivo</em>, y el historial de despliegues de un entorno, que es de
                    un entorno y no un changelog del proyecto.
                </p>

                <p className="operation__note">
                    Lo que sí está publicado y tampoco está acá son los{' '}
                    <strong>incidentes</strong> —varios tickets, o una sola señal grave,
                    agrupados con sus cuatro estados y sus tareas de corrección— y las{' '}
                    <strong>comprobaciones de recuperación</strong>, que son las que sostienen
                    la regla del tier: un despliegue exitoso no marca la recuperación, la
                    recuperación se comprueba. Esas dos se pueden construir cuando se decidan;
                    las otras dos necesitan backend primero.
                </p>
            </footer>
        </section>
    );
}
